import React from 'react';
import {
  CheckBoxOutlineBlank, 
  CheckBox as CheckBoxIcon
} from "@mui/icons-material";

import LoadingBox from "@components/input/LoadingBox";

interface Props {
  value: number;
  total: number;
  onChange: (changed: number) => void; 
  onLabelClick?: () => void;
  min?: number;
  // icon?: string;
  size?: number;
  disabled?: boolean;
  name?: React.ReactNode | string;
  name_first?: boolean;
  tooltip?: string;
}

export default function CheckBoxes({ 
  value,
  total,
  onChange,
  onLabelClick,
  min = 0,
  disabled = false,
  // icon = "",
  size = 0,
  name,
  name_first = false,
  tooltip = "",
}: Props) {

  const renderName = () => {
    if (name) {
      if (name === "Loading") {
        return (
          <LoadingBox />
        );
      } else {
        return (
          <span style={{ verticalAlign: "top" }} 
            className="clickable" 
            onClick={() => {
              if (!disabled) {
                if (onLabelClick) {
                  onLabelClick();
                } else {
                  if (value >= total) {
                    onChange(total - 1);
                  } else {
                    onChange(value + 1);
                  }
                }
              }
            }}>
            { name }
          </span>
        );
      }
    }
    return null;
  }

  const size_str = `${size}px`;
  const checkboxes: any[] = [];
  for (let i = 0; i < total; ++i) { 
    let checkbox: any;
    if (value >= i + 1) {
      const is_disabled = disabled || (i + 1 <= min);
      if (size > 0) {
        checkbox = 
          <CheckBoxIcon 
            style={{ 
              width: size_str, 
              height: size_str, 
              color: (is_disabled ? "rgb(0 0 0 / 38%)" : ""),
              cursor: (is_disabled ? "inherit" : "pointer") 
            }} 
            onClick={() => {
              if (!is_disabled) {
                onChange(value - 1);
              }
            }} 
          />;
      } else {
        checkbox = <CheckBoxIcon 
          style={{ 
            color: (is_disabled ? "rgb(0 0 0 / 38%)" : ""),
            cursor: (is_disabled ? "inherit" : "pointer")
          }} 
          onClick={() => {
            if (!is_disabled) {
              onChange(value - 1);
            }
          }} 
        />;
      }
    } else {
      if (size > 0) {
        checkbox = <CheckBoxOutlineBlank 
          style={{ 
            width: size_str, 
            height: size_str, 
            color: (disabled ? "rgb(0 0 0 / 38%)" : ""),
            cursor: (disabled ? "inherit" : "pointer") 
          }} 
          onClick={() => {
            if (!disabled) {
              onChange(value + 1);
            }
          }} 
        />;
      } else { 
        checkbox = <CheckBoxOutlineBlank 
          style={{ 
            color: (disabled ? "rgb(0 0 0 / 38%)" : ""),
            cursor: (disabled ? "inherit" : "pointer")
          }} 
          onClick={() => {
            if (!disabled) {
              onChange(value + 1);
            }
          }} 
        />;
      }
    }   
    checkboxes.push(
      <span key={i}>
        { checkbox }
      </span>
    );
  }
  if (name) {
    return (
      <span title={tooltip}>
        { name_first && renderName() }
        { checkboxes }
        { !name_first && renderName() }
      </span>
    );
  } else {
    return (
      <span style={{ cursor: "pointer" }}>
        { checkboxes }
      </span>
    );
  }
}
